import {INVE_FIELDS} from '@/constants/inve';
import {DocumentData} from '@/engine';
import {Investor, InvestorAccount} from '@/types/client-info';
import {findIndexedValuesInStore, reorderItemsByKey} from './reorder-items-by-key';

export const reorderExistingContracts = (
  oldData: DocumentData['data'],
  freshAccounts: InvestorAccount[],
): InvestorAccount[] => {
  const oldKeyValues = findIndexedValuesInStore(oldData, INVE_FIELDS.INVE43_existingAccountNo);

  return reorderItemsByKey(oldKeyValues, freshAccounts, account => account.accountNo.toString());
};

export const reorderInvestor = (investor: Investor, oldData: DocumentData['data']): Investor => ({
  ...investor,
  // Bank accounts are intentionally left untouched by refresh (out of scope).
  bankAccounts: null,
  accounts: investor.accounts ? reorderExistingContracts(oldData, investor.accounts) : investor.accounts,
});
